import Hourglass from './src/hourglass-combined';
export default Hourglass;